import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=0775fde8"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports